import React, {useEffect, useState} from 'react';
import GeofencePolygon from "../../../components/Map/GeofencePolygon";
import {centerOfGeofence, geofenceIsActive, optionsForGeofence} from "../../../utils/utils";
import {MarkerClustererF, MarkerF} from "@react-google-maps/api";

const GeofencesDisplay = ({geofences, colorIfActive, onRegularGeofenceClick, zoom,useClustering = true, baseGeofenceStyle = {}, isDashboardMap = false, }) => {

    function getOptionsForGeofence(geofence) {
        if (colorIfActive) {
            const isActive = geofenceIsActive(geofence);
            if (geofence.color) {
                if (isActive) {
                    return {
                        ...baseGeofenceStyle,
                        strokeColor: "#64bc5c",
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: geofence.color,
                        fillOpacity: 0.5,
                    };
                } else {
                    return {
                        ...baseGeofenceStyle,
                        strokeColor: "#FF0000",
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: geofence.color,
                        fillOpacity: 0.5,
                    };
                }
            } else {
                return optionsForGeofence(geofence, isActive, baseGeofenceStyle);
            }
        } else {
            return {
                ...baseGeofenceStyle,
                strokeColor: "#3e79cc",
                strokeOpacity: 0.8,
                strokeWeight: 3,
                fillColor: "#6ca1e8",
                fillOpacity: 0.5,
            };
        }
    }

    const [geofencesWithCenter, setGeofencesWithCenter] = useState(new Map());

    useEffect(() => {
        const map = new Map();
        geofences.forEach(geofence => {
          const points = geofence.enlargedPoints ?? geofence.points;
          map.set(geofence.id, {
              center: centerOfGeofence(points),
              geofence: geofence
          });
        })

        setGeofencesWithCenter(map);
    }, [geofences]);


    return (
        <>
            {geofences && geofences.map((geofence, index) => (
                <GeofencePolygon
                    key={index}
                    geofence={geofence}
                    geofenceOptions={getOptionsForGeofence(geofence)}
                    onRegularGeofenceClick={onRegularGeofenceClick}
                />
            ))
            }

            {geofencesWithCenter.size > 0 && useClustering && !isDashboardMap && <MarkerClustererF gridSize={12} >
                {cluster =>
                    Array.from(geofencesWithCenter).map(([geofenceId, {geofence, center}]) => (
                        <MarkerF
                            key={geofenceId}
                            position={center}
                            clusterer={cluster}
                            icon={{
                                url: require('../../../assets/marker-one.png'),
                                anchor: new window.google.maps.Point(25, 35)
                            }}
                            opacity={!zoom || zoom < 12 ? 1 : 0}
                            onClick={(e) => onRegularGeofenceClick(geofence, e)}
                        />
                    ))
                }
            </MarkerClustererF>}
        </>
    );
};

export default GeofencesDisplay;